import { gql } from 'apollo-boost'

export const CONFIRM_KEYS_DELIVERY_INVITATION = gql`
  mutation confirmKDEI($input: ConfirmKeysDeliveryInvitationInput!) {
    confirmKeysDeliveryInvitation(input: $input) {
      id
      isAttending
    }
  }
`
